// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 674) return "static/chunks/674-be91b0b57b7ce8da.js";
	if (chunkId === 802) return "static/chunks/69b09407-3379796d4e7a6085.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"53":"1cd251ceac07719d","678":"9716fcf490641f26","710":"0582203cf703c361","845":"de9f39863a70f97b","974":"de191918c190a6d4"}[chunkId] + ".js";
};